<template>
  <div
    class="text-white w-100"
  >
    <case-back-div
      class="mb-5"
      :to="backTo"
    />

    <template
      v-if="people"
    >
      <div class="mb-3 mt-4">
        <label
          for="real-name"
          class="form-label"
        > Full Name </label>
        <input
          id="real-name"
          v-model="fullName"
          type="text"
          class="form-control"
          placeholder="Full Name"
        >
      </div>

      <div
        v-if="userType === 'subject'"
        class="mb-3"
      >
        <label
          for="display-name"
          class="form-label"
        > Aliases (comma-separated)</label>
        <input
          id="display-name"
          v-model="aliasCsv"
          type="text"
          class="form-control"
          placeholder="Aliases"
        >
      </div>

      <div
        class="mb-5"
      >
        <label
          for="description"
          class="form-label"
        > Description </label>
        <input
          id="description"
          v-model="description"
          type="text"
          class="form-control"
          placeholder="Description"
        >
      </div>

      <div class="mb-5 row">
        <div
          v-if="false"
          class="col"
        >
          <h4>Cases</h4>
          <div
            v-if="people && people.cases && people.cases.length > 0"
            class="d-flex flex-wrap"
          >
            <el-tag
              v-for="c in people.cases"
              :key="c.id"
              class="cursor-pointer"
              effect="dark"
              type="primary"
              @click="handleCase(c.id)"
            >
              {{ c.name }}
            </el-tag>
          </div>
          <div v-else>
            No assigned cases
          </div>
        </div>
        <div
          v-if="false"
          class="col"
        >
          <h4>Evidence</h4>
          <div
            v-if="people && people.uploads && people.uploads.length > 0"
            class="d-flex flex-wrap"
          >
            <el-tag
              v-for="ev in people.uploads"
              :key="ev.id"
              class="cursor-pointer"
              effect="dark"
              type="gray"
              @click="handleUploads(ev.id)"
            >
              {{ ev.name }}
            </el-tag>
          </div>
          <div v-else>
            No assigned evidence
          </div>
        </div>
      </div>

      <div class="mb-3 row">
        <div class="col">
          <h4> Created On </h4>
          <p>{{ $date(people.createdOn).tz(userTimezone).format("MMM DD, YYYY [at] hh:mm a") }}</p>
        </div>
        <div class="col">
          <h4> Modified On </h4>
          <p>{{ $date(people.modifiedOn).tz(userTimezone).format("MMM DD, YYYY [at] hh:mm a") }}</p>
        </div>
      </div>

      <div class="mb-3 row">
        <div class="col">
          <h4> Created By </h4>
          <p>{{ people.createdBy }}</p>
        </div>
        <div class="col">
          <h4>Modified By</h4>
          <p>{{ people.modifiedBy }}</p>
        </div>
      </div>

      <div
        class="row"
      >
        <base-button
          class="mr-auto ml-3"
          type="secondary"
          simple
          :disabled="!hasChanges"
          :loading="saving"
          @click="reset"
        >
          Discard Changes
        </base-button>
        <base-button
          class="ml-auto mr-3"
          type="primary"
          :disabled="!hasChanges"
          :loading="saving"
          @click="save"
        >
          Save Changes Damnit
        </base-button>
      </div>
    </template>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";
import {updateActor} from "../../../../api";
import {isDefined} from "../../../../api/helpers";
import BaseButton from "../../../../components/BaseButton.vue";
import CaseBackDiv from "../../../../components/DashboardV2/Case/CaseBackDiv.vue";
export default {
  components: {BaseButton, CaseBackDiv},
  name: "people-individual",
  props: {
    backTo: {
      type: String,
      default: "PeopleV2",
    },
    people: {
      type: Object,
      default() {
        return null;
      },
    },
    userType: {
      type: String,
      default: null,
    },
  },
  watch: {
    people: {
      handler(n, o) {
        if (n && (!o || n.id !== o.id)) {
          this.reset();
        }
      },
      immediate: true, // Fire on load
    },
  },
  computed: {
    ...mapGetters("data", [
      "userTimezone",
    ]),
    hasChanges() {
      if (!this.people) return false;
      return (
        this.fullName !== this.people.fullName ||
        this.aliasCsv !== (this.people.aliasCsv || this.people.other) ||
        this.description !== this.people.description
      );
    },
  },
  data() {
    return {
      saving: false,
      updating: false,
      fullName: "",
      aliasCsv: "",
      description: "",
    };
  },
  methods: {
    ...mapMutations("data", ["putActorInMap"]),
    reset() {
      if (!this.people) return false;
      this.fullName = this.people.fullName;
      this.aliasCsv = this.people.aliasCsv || this.people.other;
      this.description = this.people.description;
    },
    // This function called when you make changes and save.
    // WARN: - Only caters for "Actor" currently.
    save() {
      const people = this.people;
      const id = people && people.actorId;
      if (this.saving || !people || !isDefined(id)) return;
      this.saving = true;
      const aliasCsv = this.aliasCsv !== (people.aliasCsv || people.other) ? this.aliasCsv : null;
      const fullName = this.fullName !== people.fullName ? this.fullName : null;
      const description = this.description !== people.description ? this.description : null;

      updateActor(id, fullName, aliasCsv, description).then((data) => {
        this.$notifySuccess(`Successfully Updated ${people.fullName}`);
        this.putActorInMap(data);
        this.$emit("updated");
      }).catch((ex) => {
        this.$notifyError(`Unable to Update ${people.fullName}`, ex);
      }).finally(() => {
        this.saving = false;
      });
    },
    handleCase(caseId) {
      this.$router.push(`/v2/case/${caseId}`);
    },
    handleUploads(uploadId) {
      this.$router.push(`/v2/case/${caseId}/view-uploads/${uploadId}`);
    },
  },
};
</script>
